<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="header-side"></div>
    <div class="dialog-title-text" cdkDragHandle>
        Sampling Frequencies (Stream ID: {{ streamId }})
    </div>
    <button mat-icon-button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content style="margin-top: 10px;overflow-x: hidden;">
    @if(controlPermissions.addButton){
        <div style="text-align: end;margin-bottom: 10px;">
            <button  mat-raised-button color="primary" mat-primary (click)="openAddEditForm(null, 'Add')">
                <mat-icon>add</mat-icon>
                Add Sampling Frequency
            </button>
        </div>
    }
    <div class="gridheight mat-elevation-z8 viewport">
        <table mat-table [dataSource]="dataSource"  multiTemplateDataRows matSort>

            <ng-container matColumnDef="typeName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Sampling Type </th>
                <td mat-cell *matCellDef="let element"> {{element.typeName}} </td>
            </ng-container>

            <ng-container matColumnDef="freqTypeName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Frequency Type </th>
                <td mat-cell *matCellDef="let element"> {{ element.freqTypeName  }} </td>
            </ng-container>

            <ng-container matColumnDef="testingTypeName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Testing Type </th>
                <td mat-cell *matCellDef="let element"> {{element.testingTypeName}} </td>
            </ng-container>

            <ng-container matColumnDef="sampleUpOnFirstDelivery">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Take Sample upon<br />first delivery </th>
                <td mat-cell *matCellDef="let element"> {{element.sampleUpOnFirstDelivery ?? false}} </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions</th>
                <td mat-cell *matCellDef="let row">
                    <div>
                        <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit" (click)="openAddEditForm(row, 'Edit')">
                            <mat-icon>edit</mat-icon>
                        </button>
                        @if (controlPermissions.delete){
                            <button mat-icon-button type="button" color="warn" title="Delete" (click)="onDeleteSamplingFreq(row.id, row.typeName)" style="color: red;">
                                <mat-icon>delete</mat-icon>
                            </button>
                        }
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</mat-dialog-content>

<!-- Footer for closing the dialog -->
<mat-dialog-actions align="end" class="dialog-footer">
    <button (click)="close()" mat-raised-button color="primary" mat-primary>
        Close
    </button>
</mat-dialog-actions>